import type {HTMLAttributes, ReactNode} from "react";

export type DsBadgeVariant = "default" | "primary" | "sale" | "success" | "warning";

export type DsBadgeProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: DsBadgeVariant;
  children: ReactNode;
};

export function DsBadge({variant = "default", className, children, ...props}: DsBadgeProps) {
  const cls = ["cc-ds-badge", `cc-ds-badge--${variant}`, className || ""].filter(Boolean).join(" ");
  return <span className={cls} {...props}>{children}</span>;
}
